import { Space, Spin } from 'antd'
import React from 'react'
import './Loading.css'

const LoadingComponent = () => {
return (
    <div className="loading-container">
    <Space direction="vertical" style={{ width: '100%' }}>
        <Spin tip="Loading" size="large" className="content">
        <div className="loading" />
        </Spin>
    </Space>
    </div>
)
}

export default LoadingComponent
